import { Link } from 'react-router-dom';
import { route as LOGIN_ROUTE } from '../../features/login';

import './style.scss';
import {clearAllForgotPasswordAlerts, clearLoginErrors} from "../../actions/session";
import {clearAllUserAlerts} from "../../actions/users";
import {useDispatch} from "react-redux";


const AccountLinks = (props) => {
  const dispatch = useDispatch();
  const clearUserErrors = () => {
    dispatch(clearLoginErrors());
    dispatch(clearAllForgotPasswordAlerts());
    dispatch(clearAllUserAlerts());
  }

  return (
      <div className="account-links">
        <Link to={LOGIN_ROUTE} onClick={() => clearUserErrors()} className="login-link">Log in</Link>
      </div>
  );
};

export default AccountLinks;
